<template>
  <div class="container1"  v-wechat-title="$store.state.region.re_name +'-游记参赛'">
    <new-top :title="this.$route.params.title">
      <div slot="rightBtn">
        <span class="rightBtn" @click="tofromData">发表</span>
      </div>
    </new-top>
    <div class="youji" style="padding-top: 44px">
      <div class="fengmian">
        上传封面
        <input
          @change="imageChange"
          type="file"
          accept="image/*"
          id="file_btn"
        />
        <img v-show="flagIsShow" :src="imgInfo.cover_path" alt="" />
        <span @click="delelt" v-show="flagIsShow">×</span>
      </div>

      <!-- 信息弹出层 -->
      <van-popup
        v-model="show"
        closeable
        round
        :close-on-click-overlay="false"
        @click-close-icon="iconClick"
        close-icon-position="top-left"
        :style="{ height: '80%', width: '90%' }"
      >
        <div class="adddata">
          <div class="adddataList">
            <div class="left">
              <img src="@/assets/images/baoming/shuming.png" alt="" />
              <span>作者署名</span>
            </div>
            <input
              v-model="addressData.signup_username"
              class="right"
              type="text"
              placeholder="请输入您的作者署名"
            />
          </div>
          <div class="adddataList">
            <div class="left">
              <img src="@/assets/images/baoming/mingcheng.png" alt="" />
              <span>作品简介</span>
            </div>
            <!-- <input v-model="addressData.signup_username" class="right" type="text" placeholder="请输入您的作品简介" /> -->
            <van-field
              v-model="addressData.signup_dec"
              rows="2"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="请输入您的作品简介"
              show-word-limit
            />
          </div>
          <p class="jingao">(以下信息为参赛要求非公开，仅主办方收到)</p>
          <div class="adddataList">
            <div class="left">
              <img src="@/assets/images/baoming/xingming.png" alt="" />
              <span>真实姓名</span>
            </div>
            <input
              @blur="dname(addressData.signup_true_name)"
              v-model="addressData.signup_true_name"
              class="right"
              type="text"
              placeholder="请输入您的真实姓名"
            />
          </div>
          <div class="adddataList">
            <div class="left">
              <img src="@/assets/images/baoming/qiye.png" alt="" />
              <span>通讯地址</span>
            </div>
            <!-- <input class="right" type="text" placeholder="请输入您的通讯地址" /> -->
            <van-field
              v-model="addressData.signup_address"
              rows="2"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="请输入您的通讯地址"
              show-word-limit
            />
          </div>
          <div class="adddataList">
            <div class="left">
              <img src="@/assets/images/baoming/shouji.png" alt="" />
              <span>联系手机</span>
            </div>
            <input
              @blur="dphone(addressData.signup_phone)"
              v-model="addressData.signup_phone"
              class="right"
              type="number"
              placeholder="请输入您的手机号码"
            />
          </div>
          <div class="adddataList">
            <div class="left" style="width: 76px; height: 40px">
              <span></span>
            </div>
            <input
              v-model="addressData.phone_code"
              class="right"
              type="text"
              placeholder="输入验证码"
            />
            <span class="pos" @click="time">{{ text }}</span>
          </div>
        </div>
        <div class="btnciclk" @click="tofrom">确认</div>
      </van-popup>
      <!-- 游记 -->
      <div>
        <div style="padding-left: 12px">
          <van-field
            v-model="addressData.signup_tripname"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入游记标题"
            show-word-limit
          />
        </div>
        <!-- 目录板块 -->
        <div class="mulu" @click="mulusClick">
          <img src="@/assets/images/muli.png" alt="" /><span>目录</span>
        </div>
        <div class="muluInfo">
          <van-popup
            v-model="mulus"
            position="left"
            :style="{ width: '60%', height: '100%' }"
          >
            <h2 style="margin-bottom: 10px">游记目录</h2>
            <div class="muluList">
              <span
                @click="toscoll(index)"
                v-for="(item, index) in mulusList"
                :key="item.index"
                >{{ index }}&nbsp;|&nbsp;{{ item }}</span
              >
            </div>
          </van-popup>
        </div>
        <!-- 音乐版块 -->
        <div class="musicInfo">
          <van-popup
            v-model="music"
            closeable
            round
            position="bottom"
            :style="{ width: '100%', height: '90%' }"
          >
            <h2 style="margin-bottom: 10px">音乐 • {{ musicList.length }}首</h2>
            <div class="disflex">
              <span>当前添加的音乐是: {{ musicTitle || "暂无" }}</span>
              <span @click="deleltMusic">删除</span>
            </div>
            <div class="musicList">
              <div
                class="musicItem"
                @click="musicClick(item, index)"
                v-for="(item, index) in musicList"
                :key="item.id"
              >
                <div class="leftimg">
                  <img :src="item.list.audio_image" alt="" />
                  <img
                    v-show="!item.flags"
                    class="play"
                    src="@/assets/images/off.png"
                    alt=""
                  />
                  <img
                    v-show="item.flags"
                    class="play"
                    src="@/assets/images/no.png"
                    alt=""
                  />
                </div>
                <div class="centertext">
                  {{ item.list.audio_name }}
                </div>
                <div class="btnmusic" @click.stop="toAddImg(item)">＋ 添加</div>
                <audio :src="item.list.audio_url_all" id="musicFS"></audio>
              </div>
              <!-- 音乐 -->
            </div>
          </van-popup>
        </div>
        <!-- 底部选择栏 -->
        <!-- <div class="footers" @click="addBt">按钮</div> -->
        <p class="ppp">点击文本选择副标题可添加游记的副标题</p>
        <!-- 富文本 -->
        <quill-editor
          v-model="addressData.signup_tripdetail"
          ref="myQuillEditor"
          :options="editorOption"
          @focus="onEditorFocus($event)"
          @blur="onEditorBlur($event)"
          @change="onEditorChange($event)"
          class="editor"
        ></quill-editor>

        <form
          action
          method="post"
          enctype="multipart/form-data"
          id="uploadFormMulti"
        >
          <input
            style="display: none"
            :id="uniqueId"
            type="file"
            name="file"
            multiple
            accept="image/jpg, image/jpeg, image/png, image/gif"
            @change="uploadImg()"
          />
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import newTop from "@/components/travel/newTop.vue";
import {
  del_img,
  xiaoxi,
  match_themetripcompetion,
  thetripaudiolist,
} from "@/api/travel";
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  //   [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  //   [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  //   [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [2, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  //   [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["image"], // 链接、图片、视频-----['link', 'image', 'video']
];
export default {
  data() {
    return {
      imgInfo: {},
      text: "获取验证码",
      flagimage: true,
      flagIsShow: false,
      show: true,
      flagname: false,
      flag: true,
      flags: false,
      mulus: false,
      music: false,
      musicPlay: "",
      musicflag: [],
      musicTitle: "",
      mulusList: [],
      scollList: [],
      musicList: [],
      addressData: {
        // 游记主题名称
        signup_tripname: "",
        // 游记主题封面图
        signup_tripimage: "",
        // 大赛主题的id
        shoot_id: "",
        // 游记大赛详情
        signup_tripdetail: "",
        // 作者署名
        signup_username: "",
        // 游记大赛简介
        signup_dec: "",
        // 作者的真实姓名
        signup_true_name: "",
        // 参赛预留手机号
        signup_phone: "",
        // 用户通讯地址
        signup_address: "",
        // 手机验证码
        phone_code: "",
        // 验证码对应的id
        phone_code_id: "",
        //是否有音乐
        is_audio: 0,
        RegIdProvince: "1",
        RegIdCity: "",
        RegIdDistrict: "",
      },
      imgList: [],
      uniqueId: "uniqueId",
      content: ``, // 富文本编辑器默认内容
      editorOption: {
        //  富文本编辑器配置
        modules: {
          //工具栏定义的
          toolbar: toolbarOptions,
        },
        //主题
        theme: "snow",
        placeholder: "请输入正文",
      },
    };
  },
  computed: {
    //当前富文本实例
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  components: {
    newTop,
  },
  mounted() {
    this.$nextTick(() => {
      $(".ql-toolbar").append(`<div class="imgcc" onClick="addImg()"></div>`);
      //此方法可以在metdos里用
      window.addImg = this.addImg;
    });
    var _this = this;
    var imgHandler = async function (image) {
      if (image) {
        var fileInput = document.getElementById(_this.uniqueId); //隐藏的file文本ID
        fileInput.click(); //加一个触发事件
      }
    };
    _this.editor.getModule("toolbar").addHandler("image", imgHandler);
  },
  methods: {
    // 添加音乐
    addImg() {
      this.music = true;
    },
    //添加到data里暂存
    toAddImg(item) {
      this.musicTitle = item.list.audio_name;
      this.addressData.audiourl = item.list.audio_url;
      this.addressData.is_audio = 1;
      // console.log(this.addressData);
    },
    //点谁播放谁
    musicClick(item, index) {
      let music = document.getElementsByTagName("audio");
      this.musicPlay = item.list.audio_url_all;
      this.musicList.forEach((v, index) => {
        v.flags = false;
        music[index].pause();
        music[index].currentTime = 0;
      });
      //如果不是2就点那个播放哪个，是2就为播放第二次全部暂停
      if (this.musicList[index].num != 2) {
        this.musicList[index].flags = true;
        this.musicList.forEach((v, index) => {
          v.num = 1;
        });
      } else {
        this.musicList.forEach((v, index) => {
          v.num = 1;
        });
      }
      if (this.musicList[index].flags) {
        music[index].play();
        this.musicList[index].num = 2;
      }
      if (!this.musicList[index].flags) {
        music[index].pause();
      }
    },
    //删除音乐
    deleltMusic() {
      delete this.addressData.audiourl;
    },
    //图片上传
    imageChange(e) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "",
      });
      toast.message = `上传中,请耐心等待`;
      // 此时可以自行将文件上传至服务器
      let formData = new FormData(); /*创建formData对象*/
      // //Base64字符串转二进制
      formData.append("type", 3);
      formData.append("coverimg", e.target.files[0]);
      this.$http.post("/index.php/api/travel/upload_img", formData).then((res) => {
        this.imgInfo = res.data.data;
        this.addressData.signup_tripimage = res.data.data.path;
        // console.log(res);
        this.flagIsShow = true;
        //通过定时器来实时判断图片是否上传成功
        this.timer = setInterval(() => {
          if (res.data.data) {
            clearInterval(this.timer);
            this.$toast.clear();
          }
        }, 50);
      });
    },
    // 删除图片
    delelt() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除此图片?",
        })
        .then(() => {
          this.$toast.loading("删除中...");
          del_img({
            type: 1,
            img_name: this.imgInfo.path,
          }).then((res) => {
            // console.log(res);
            this.flagIsShow = false;
            this.$toast("删除成功");
            this.imgInfo = {};
          });
        })
        .catch(() => {});
    },
    // 姓名验证
    dname(val) {
      let name = /^[\u4e00-\u9fa5]{2,10}$/;
      if (!name.test(val)) {
        this.$toast("姓名格式错误");
        this.flagname = false;
      } else {
        return (this.flagname = true);
      }
    },
    dphone(val) {
      // 手机号验证规则
      let phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // 判断是否有18位或者15位
      if (!phone.test(val)) {
        this.$toast("手机格式错误");
        return (this.flags = false);
      } else {
        return (this.flags = true);
      }
    },
    //验证码
    time() {
      if (this.flag && this.addressData.signup_phone && this.flags) {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        xiaoxi({ phone: this.addressData.signup_phone }).then((res) => {
          this.addressData.phone_code_id = res.code_data.code_id;
          this.flag = false;
          let num = 60;
          this.timer = setInterval(() => {
            this.$toast.clear();
            if (num == 0) {
              this.text = "获取验证码";
              this.flag = true;
              clearInterval(this.timer);
              return;
            } 
            // else if (num == 56) {
            //   this.$dialog
            //     .alert({
            //       title: "验证码",
            //       message: res.code_data.code,
            //     })
            //     .then(() => {});
            // }
            this.text = num + "s";
            num--;
          }, 1000);
        });
      }
    },
    //确认
    tofrom() {
      if (
        this.addressData.signup_username != "" &&
        this.addressData.signup_dec != "" &&
        this.addressData.signup_true_name != "" &&
        this.addressData.signup_address != "" &&
        this.addressData.signup_phone != "" &&
        this.addressData.phone_code != "" &&
        this.flagname &&
        this.flags
      ) {
        this.addressData.shoot_id = this.$route.params.id;
        this.show = false;
      } else {
        this.$toast("请正确填写或填写完整");
      }
    },
    //点击关闭后返回上一页
    iconClick() {
      this.$router.back();
    },
    // 准备富文本编辑器
    onEditorReady() {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(e) {
      this.mulusList = [];
      this.scollList = [];
      let arr = $(".ql-editor h2");
      for (let i = 0; i < arr.length; i++) {
        this.scollList.push($(".ql-editor h2")[i].offsetTop);
      }
      console.log(this.scollList);
      for (let k of arr) {
        this.mulusList.push(k.innerHTML);
      }
    },
    // 富文本编辑器 获得焦点事件
    onEditorFocus() {},
    // 富文本编辑器 内容改变事件
    onEditorChange({ editor, html, text }) {
      //console.log(text)
      console.log(this.addressData.signup_tripdetail);
    },
    toscoll(index) {
      this.mulus = false;
      $(".ql-editor").animate({ scrollTop: this.scollList[index] }, 500);
    },
    mulusClick() {
      this.mulus = true;
    },
    addBt() {
      console.log(this.editor.quill.getLength());
      // this.editor.insertText(0, 'Hello', 'bold', true);
    },
    uploadImg() {
      var _this = this;
      //构造formData对象
      var formData = new FormData();
      formData.append("type", 3);
      formData.append(
        "coverimg",
        document.getElementById(_this.uniqueId).files[0]
      );
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
      });

      this.$http.post("/index.php/api/travel/upload_img", formData).then((res) => {
        console.log(res);
        _this.imgList.push({
          cover_path: res.data.data.cover_path,
          path: res.data.data.path,
        });
        let Range = _this.editor.getSelection();
        let length = _this.editor.getSelection().index;
        // _this.editor.insertEmbed(
        //   Range != null ? Range.index : 0,
        //   "image",
        //   res.data.data.cover_path
        // );
        _this.editor.insertEmbed(length, "image", res.data.data.cover_path); // 这里的url是图片的访问路径不是真实物理路径
        _this.editor.setSelection(length + 1);
        this.$toast.clear();
      });
    },

    //提交
    tofromData() {
      this.addressData.RegIdCity = JSON.parse(
        localStorage.getItem("regionList")
      ).ParentID;
      this.addressData.RegIdDistrict = JSON.parse(
        localStorage.getItem("regionList")
      ).id;
      // console.log(this.addressData);
      if (
        this.addressData.signup_username != "" &&
        this.addressData.signup_dec != "" &&
        this.addressData.signup_true_name != "" &&
        this.addressData.signup_address != "" &&
        this.addressData.signup_phone != "" &&
        this.addressData.phone_code != "" &&
        this.addressData.signup_tripname != "" &&
        this.addressData.signup_tripdetail != "" &&
        this.addressData.shoot_id
      ) {
        this.$dialog
          .confirm({
            title: "标题",
            message: "确认参赛吗?",
          })
          .then(() => {
            match_themetripcompetion(this.addressData).then((res) => {
              this.flagimage = false;
              console.log(res);
              // this.$toast("提交成功,请等待审核")
              this.$toast({
                forbidClick: true,
                message: "提交成功,请等待审核",
              });
              setTimeout(() => {
                this.$router.back();
              }, 2000);
            });
          })
          .catch(() => {});
        //   this.$toast.loading({
        //   message: "提交中...",
        //   forbidClick: true,
        // });
      } else {
        this.$toast({
          duration: 2000, // 持续展示 toast
          forbidClick: true,
          message: "请正确填写或填写完整",
        });
      }
    },
  },
  created() {
    thetripaudiolist({
      page: 1,
    }).then((res) => {
      // console.log(res);
      // this.musicList = res.audio_list.data;
      res.audio_list.data.forEach((v, index) => {
        this.musicList.push({
          list: [],
          flags: false,
          num: 1,
        });
        this.musicList[index].list = v;
      });
    });
  },
  //用户直接返回不发表 销毁时删除所有图片
  beforeDestroy() {
    if (this.imgInfo.path && this.flagimage) {
      let arr = [];
      this.imgList.forEach((v) => {
        arr.push(v.path);
      });
      arr.push(this.imgInfo.path);
      del_img({
        type: 2,
        img_name: arr.join("#"),
      }).then((res) => {
        // console.log(res);
      });
    }
  },
};
</script>
<style scoped>
.disflex {
  display: flex;
  justify-content: space-between;
  font-size: 0.26rem;
}
.disflex span:first-child {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.disflex span:last-child {
  width: 40px;
}
.musicItem {
  display: flex;
  align-items: center;
  position: relative;
  line-height: 72px;
}
.musicItem .leftimg {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
.musicItem img {
  width: 48px;
  height: 48px;
  margin-right: 10px;
}
.musicItem .centertext {
  flex: 1;
  text-align: left;
  font-weight: bold;
  font-size: 0.3rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.musicItem .btnmusic {
  font-size: 0.3rem;
  color: #666;
}
.musicItem .play {
  width: 30px;
  height: 30px;
  position: absolute;
}
.musicInfo .van-popup {
  padding: 20px;
  text-align: center;
}
.rightBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.mulu {
  position: fixed;
  left: 0;
  bottom: 10%;
  z-index: 9;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  background-color: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 4px 6px;
}
.mulu .van-popup {
  padding: 4px 8px;
}
.mulu img {
  width: 20px;
  height: 20px;
}
.muluList {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.muluList span {
  line-height: 30px;
  border-bottom: 1px solid #eeeeee;
}
.muluList span:first-child {
  border-top: 1px solid #eeeeee;
}
.muluInfo .van-popup {
  padding: 20px 16px;
}
.ppp {
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #666;
}
.container1 {
  background-color: #fff;
}
.youji {
}
.youji .fengmian {
  height: 3rem;
  background-color: #f7f8fa;
  margin: 0 10px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.youji .fengmian img {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
}
.fengmian span {
  width: 30px;
  height: 30px;
  position: absolute;
  font-size: 0.8rem;
  color: #fff;
  background-color: red;
  border-radius: 50%;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 8;
}
#file_btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
}
.van-popup {
  padding: 40px 20px;
}
.adddataList img {
  width: 14px;
  height: 16px;
  margin-right: 6px;
}
.adddata {
  padding: 0 12px;
}
.adddataList {
  display: flex;
  border-top: 1px solid #e5e5e5;
  line-height: 40px;
  position: relative;
  padding: 0;
}
.adddataList:first-child {
  border-top: 0;
}
.adddataList:last-child {
  border-bottom: 1px solid #e5e5e5;
}
.adddata p {
  font-size: 12px;
  display: flex;
  justify-content: center;
}
.adddataList .left {
  color: #ea6a00;
  font-size: 14px;
  min-width: 90px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.adddataList .van-cell{
  width: 170px;
}
.van-cell {
  padding-left: 0;
}
.adddataList input {
  font-size: 14px;
}
.pos {
  position: absolute;
  right: 10px;
  background-color: #fff;
  color: #ea6a00;
  font-size: 14px;
}
.btnciclk {
  width: 40%;
  border-radius: 20px;
  background-image: linear-gradient(#ffaa8e, #e95b2d);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 50px;
  padding: 8px 0px;
}
.footers {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 99;
  line-height: 44px;
  background-color: #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}
</style>
<style>
.imgcc {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: url("../../assets/images/musictAdd.png");
  background-size: 100%;
  vertical-align: middle;
}
.ql-toolbar {
  position: relative;
}
.editor {
  line-height: normal !important;
  height: 500px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "副标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>